import apiWrapper from 'Helpers/apiWrapper'
import { encodeParams } from 'mailup-react-helpers'

const endpoints = ((baseURL) => {
  /* eslint-disable prettier/prettier */
  return {
    //  AsyncOperations
    unsubscribeBySearchParams: (idList) =>
      `${baseURL}/api/unsubscribe/list/${encodeURIComponent(
        idList,
      )}/searchparams`,
    unsubscribeBySelectionParams: (idList, qsParams) =>
      `${baseURL}/api/unsubscribe/list/${encodeURIComponent(
        idList,
      )}/selectionparams?${encodeParams(qsParams)}`,

    unsubscribeByCustomSearchParams: (idList, qsParams) =>
      `${baseURL}/api/unsubscribe/list/${encodeURIComponent(
        idList,
      )}/customsearchparams?${encodeParams(qsParams)}`,

    exportBySelectionParams: (idList, qsParams) =>
      `${baseURL}/api/export/list/${encodeURIComponent(
        idList,
      )}/selectionparams?${encodeParams(qsParams)}`,

    exportByCustomSearchParams: (idList, qsParams) =>
      `${baseURL}/api/export/list/${encodeURIComponent(
        idList,
      )}/customsearchparams?${encodeParams(qsParams)}`,

    //  Segmentation
    searchForRecipients: (idList, params) =>
      `${baseURL}/api/list/${encodeURIComponent(idList)}/search?${encodeParams(
        params,
      )}`,
    lazySearchForRecipients: (idList, params) =>
      `${baseURL}/api/list/${encodeURIComponent(
        idList,
      )}/lazysearch?${encodeParams(params)}`,

    //  Groups
    getListOfGroupDetails: (idList, params) =>
      `${baseURL}/api/list/${encodeURIComponent(idList)}/groups?${encodeParams(
        params,
      )}`,
    getGroupDetails: (idGroup) =>
      `${baseURL}/api/groups/${encodeURIComponent(idGroup)}`,
    addGroup: `${baseURL}/api/groups`,
    updateGroup: (idGroup) =>
      `${baseURL}/api/groups/${encodeURIComponent(idGroup)}`,

    //  SubscriptionEmail
    optoutEmailRecipientFromList: (idRecipient, idList, flags) =>
      `${baseURL}/api/email/recipients/${encodeURIComponent(
        idRecipient,
      )}/subscription/list/${encodeURIComponent(idList)}/optout?${encodeParams(
        flags,
      )}`,
    getEmailSubscriptionFromList: (idRecipient, idList) =>
      `${baseURL}/api/email/recipients/${encodeURIComponent(
        idRecipient,
      )}/subscription/list/${encodeURIComponent(idList)}`,

    //  SubscriptionSms
    optoutSmsRecipientFromList: (idRecipient, idList, flags) =>
      `${baseURL}/api/sms/recipients/${encodeURIComponent(
        idRecipient,
      )}/subscription/list/${encodeURIComponent(idList)}/optout?${encodeParams(
        flags,
      )}`,

    getGroupDetailsByIds: `${baseURL}/api/groups/ids`,

    //  Group Assignment
    getRecipientGroupAssignements: (idRecipient, qsParams) =>
      `${baseURL}/api/recipients/${idRecipient}/assignements?${encodeParams(qsParams)}`,
    assignRecipientToGroup: (idRecipient, idGroup, idList) =>
      `${baseURL}/api/recipients/${idRecipient}/group/${idGroup}/list/${idList}`,
    removeRecipientFromGroup: (idRecipient, idGroup, idList) =>
      `${baseURL}/api/recipients/${idRecipient}/group/${idGroup}/list/${idList}`,

    copyMoveRecipientsToGroupBySearch: (idList, idGroup) =>
      `${baseURL}/api/recipient/group/${encodeURIComponent(
        idGroup,
      )}/list/${encodeURIComponent(idList)}/searchparams`,
    copyMoveRecipientsToGroupByManualSelection: (idList, idGroup) =>
      `${baseURL}/api/recipient/group/${encodeURIComponent(
        idGroup,
      )}/list/${encodeURIComponent(idList)}/selectionparams`,
    copyMoveRecipientsToGroupByCustomSearch: (idList, idGroup) =>
      `${baseURL}/api/recipient/group/${encodeURIComponent(
        idGroup,
      )}/list/${encodeURIComponent(idList)}/customsearchparams`,

    //  Registry
    getRecipient: (idRecipient) =>
      `${baseURL}/api/recipients/${encodeURIComponent(idRecipient)}`,
    updateRecipient: (idRecipient) =>
      `${baseURL}/api/recipients/${encodeURIComponent(idRecipient)}`,

    deleteRecipient: (idList, idRecipient) =>
      `${baseURL}/api/recipients/${encodeURIComponent(
        idRecipient,
      )}/list/${encodeURIComponent(idList)}`,

    //  Anagraphic fields
    getDynamicFieldsDefinition: `${baseURL}/api/fields`,

    // Unsubscribed chart
    getOptoutType: (idList) =>
      `${baseURL}/api/email/list/${encodeURIComponent(
        idList,
      )}/stats/unsubscription/optouttype`,
    // Tracking
    getEmailRecipientTracking: (idRecipient, idList) =>
      `${baseURL}/api/email/recipients/${encodeURIComponent(idRecipient)}/tracking/list/${encodeURIComponent(idList)}`,
    updateEmailRecipientTracking: (idRecipient, idList) =>
      `${baseURL}/api/email/recipients/${encodeURIComponent(idRecipient)}/tracking/list/${encodeURIComponent(idList)}`,

    //  SubscriptionSms
    getSmsSubscriptionFromList: (idRecipient, idList) =>
      `${baseURL}/api/sms/recipients/${encodeURIComponent(
        idRecipient,
      )}/subscription/list/${encodeURIComponent(idList)}`,
    getEmailSubscriptionData: (idList, idRecipient) =>
      `${baseURL}/api/email/recipients/${encodeURIComponent(
        idRecipient,
      )}/subscription/list/${encodeURIComponent(idList)}`,

    // Activities
    getEmailRecipientActivity: (idList, idRecipient, params) =>
      `${baseURL}/api/email/recipients/${encodeURIComponent(
        idRecipient,
      )}/list/${encodeURIComponent(idList)}/activity?${encodeParams(params)}`,
    getSmsRecipientActivity: (idList, idRecipient, params) =>
      `${baseURL}/api/sms/recipients/${encodeURIComponent(
        idRecipient,
      )}/list/${encodeURIComponent(idList)}/activity?${encodeParams(params)}`,

    // Inactive Recipients Configuration
    inactiveRecipientsConfiguration: (idList) =>
      `${baseURL}/api/list/${encodeURIComponent(idList)}/recipient/inactive/configuration`,
    getInactiveRecipientsCount: (idList, monthsPeriod) =>
      `${baseURL}/api/list/${encodeURIComponent(idList)}/recipient/inactive/count?${encodeParams({ monthsPeriod })}`,

    //  Segmentation
    customSearchForRecipients: (idList, qsParams) =>
      `${baseURL}/api/list/${idList}/customsearch?${encodeParams(qsParams)}`,
    hasRecipients: (idList) => `${baseURL}/api/list/${idList}/hasrecipients`,

    //  Confidentials
    getLoginConfidentialDefinitions: (idLogin) =>
      `${baseURL}/api/login/${idLogin}/confidentials`,
  }
  /* eslint-enable prettier/prettier */
})(process.env.BERECIPIENT_URL)

/**
 *
 * @param {number} idList The list id
 * @param {Object} params
 * @param {('All'|'Email'|'Sms')} params.channel
 * @param {('Subscribed'|'Pending'|'Unsubscribed')} params.status
 * @param {number} params.pageSize Number of sources returned
 * @param {number} params.pageNumber Page number
 * @param {('Field1'|'Field-n'|'Id'|'Email'|'MobilePrefix'|'MobileNumber'|'MobilePrefixAndNumber'|'SubscriptionDate'|'SubscriptionRequestDate'|'OptoutDate'|'Hash')} params.orderBy
 * @param {boolean} params.orderDescending Order descending
 * @param {boolean} params.evaluateSelectionBlackout Include recipients based on count_sent, date_from and date_to in optin (Email channel only)
 * @param {boolean} params.excludeFields
 *
 * @param {Object} searchConditions
 * @param {Object} searchConditions.DateRanges
 * @param {string} searchConditions.DateRanges.From ISO string date
 * @param {string} searchConditions.DateRanges.To ISO string date
 * @param {Array<number>} searchConditions.IncludeGroups
 * @param {Array<number>} searchConditions.ExcludeGroups
 * @param {Array<Object>} searchConditions.MatchingFields {Id: 0, Value: string}
 * @param {Object} searchConditions.MatchingFilters
 * @param {('All'|'AtLeastOne')} searchConditions.MatchingFilters.Condition
 * @param {Array<number>} searchConditions.MatchingFilters.Filters
 * @param {string} searchConditions.UnsubscriptionType
 * @param {string} searchConditions.UnsubscriptionSubType
 * @param {number} searchConditions.UnsubscriptionMessage
 * @param {string} searchConditions.Email
 * @param {('EXACT'|'CONTAINS'|'STARTWITH'|'ENDWITH')} searchConditions.EmailMatchType
 * @param {string} searchConditions.MobilePrefix
 * @param {string} searchConditions.MobileNumber
 *
 */
export const beRecipientSearchForRecipients = (
  idList,
  params,
  searchConditions,
) => {
  const url = endpoints.searchForRecipients(idList, params)
  return apiWrapper({
    method: 'post',
    url,
    data: JSON.stringify(searchConditions),
    headers: {
      'Content-Type': 'application/json',
    },
  }).then(({ data }) => data)
}

/**
 *
 * @param {number} idList The list id
 * @param {Object} params
 * @param {('All'|'Email'|'Sms')} params.channel
 * @param {('Subscribed'|'Pending'|'Unsubscribed')} params.status
 * @param {number} params.pageSize Number of sources returned
 * @param {number} params.pageNumber Page number
 * @param {('Field1'|'Field-n'|'Id'|'Email'|'MobilePrefix'|'MobileNumber'|'MobilePrefixAndNumber'|'SubscriptionDate'|'SubscriptionRequestDate'|'OptoutDate'|'Hash')} params.orderBy
 * @param {boolean} params.orderDescending Order descending
 * @param {boolean} params.evaluateSelectionBlackout Include recipients based on count_sent, date_from and date_to in optin (Email channel only)
 * @param {boolean} params.excludeFields
 *
 * @param {Object} searchConditions
 * @param {Object} searchConditions.DateRanges
 * @param {string} searchConditions.DateRanges.From ISO string date
 * @param {string} searchConditions.DateRanges.To ISO string date
 * @param {Array<number>} searchConditions.IncludeGroups
 * @param {Array<number>} searchConditions.ExcludeGroups
 * @param {Array<Object>} searchConditions.MatchingFields {Id: 0, Value: string}
 * @param {Object} searchConditions.MatchingFilters
 * @param {('All'|'AtLeastOne')} searchConditions.MatchingFilters.Condition
 * @param {Array<number>} searchConditions.MatchingFilters.Filters
 * @param {string} searchConditions.UnsubscriptionType
 * @param {string} searchConditions.UnsubscriptionSubType
 * @param {number} searchConditions.UnsubscriptionMessage
 * @param {string} searchConditions.Email
 * @param {('EXACT'|'CONTAINS'|'STARTWITH'|'ENDWITH')} searchConditions.EmailMatchType
 * @param {string} searchConditions.MobilePrefix
 * @param {string} searchConditions.MobileNumber
 *
 */
export const beRecipientLazySearchForRecipients = (
  idList,
  params,
  searchConditions = {},
) => {
  const url = endpoints.lazySearchForRecipients(idList, params)
  return apiWrapper({
    method: 'post',
    url,
    data: JSON.stringify(searchConditions),
    headers: {
      'Content-Type': 'application/json',
    },
  }).then(({ data }) => data)
}

/**
 *
 * @param {number} idList ID of list
 * @param {Object} params
 * @param {('STARTWITH'|'ENDWITH'|'CONTAINS'|'EQUALTO')} params.searchType Value of search type
 * @param {string} params.searchBy Value to search for
 * @param {('HASEMAILRECIPIENTS'|'HASSMSRECIPIENTS'|'HASRECIPIENTS')} [params.hasRecipients] filter non empty group
 * @param {('Normal'|'Test'|'SubscriptionForm'|'AutoprofileForm'|'SocialPlus'|'Temporary')} [params.groupType] type of the group to search for
 * @param {number} params.pageSize Number of sources returned
 * @param {number} params.pageNumber Page number
 * @param {string} params.orderBy Order by specified field
 * @param {boolean} params.orderDescending Order descending
 *
 */
export const beRecipientGetListOfGroupDetails = (idList, params) => {
  const url = endpoints.getListOfGroupDetails(idList, params)
  return apiWrapper({
    method: 'get',
    url,
  }).then(({ data }) => data)
}

/**
 * @description Put the recipient in the specified list in optout state
 * @param {number} idRecipient ID of recipient
 * @param {number} idList ID of list
 * @param {Object} flags
 * @param {boolean} flags.changeFromOptin
 * @param {boolean} flags.changeFromPending
 * @param {boolean} flags.changeFromOptout
 * @param {('Any'|'Platform'|'NewsletterLink'|'Import'|'BounceHB'|'FBL'|'UnsubHttp'|'UnsubMailTo'|'Inactive'|'MailBlocked'|'NBH'|'Oblio')} OptOutType
 * @param {string} RemoteIp
 */
export const beRecipientOptoutEmailRecipientFromList = (
  idRecipient,
  idList,
  flags,
  OptOutType,
  RemoteIp = '',
) => {
  const url = endpoints.optoutEmailRecipientFromList(idRecipient, idList, flags)
  return apiWrapper({
    method: 'put',
    url,
    data: JSON.stringify({ OptOutType, RemoteIp }),
    headers: {
      'Content-Type': 'application/json',
    },
  }).then(({ data }) => data)
}

/**
 * @description Put the recipient in the specified list in optout state
 * @param {number} idRecipient ID of recipient
 * @param {number} idList ID of list
 * @param {Object} flags
 * @param {boolean} flags.changeFromOptin
 * @param {boolean} flags.changeFromPending
 * @param {boolean} flags.changeFromOptout
 * @param {('Any'|'Platform'|'NewsletterLink'|'Import'|'BounceHB'|'FBL'|'UnsubHttp'|'UnsubMailTo'|'Inactive'|'MailBlocked'|'NBH'|'Oblio')} OptOutType
 * @param {string} RemoteIp
 */
export const beRecipientOptoutSmsRecipientFromList = (
  idRecipient,
  idList,
  flags,
  OptOutType,
  RemoteIp = '',
) => {
  const url = endpoints.optoutSmsRecipientFromList(idRecipient, idList, flags)
  return apiWrapper({
    method: 'put',
    url,
    data: JSON.stringify({ OptOutType, RemoteIp }),
    headers: {
      'Content-Type': 'application/json',
    },
  }).then(({ data }) => data)
}

/**
 * @description Unsubscribe recipients from a list filtered by search parameters
 * @param {number} idList ID of list
 * @param {Object} SearchRecipientsData
 * @param {Object} SearchRecipientsData.DateRanges
 * @param {string} SearchRecipientsData.DateRanges.From ISO string date
 * @param {string} SearchRecipientsData.DateRanges.To ISO string date
 * @param {Array<number>} SearchRecipientsData.IncludeGroups
 * @param {Array<number>} SearchRecipientsData.ExcludeGroups
 * @param {Array<Object>} SearchRecipientsData.MatchingFields {Id: 0, Value: string}
 * @param {Object} SearchRecipientsData.MatchingFilters
 * @param {('All'|'AtLeastOne')} SearchRecipientsData.MatchingFilters.Condition
 * @param {Array<number>} SearchRecipientsData.MatchingFilters.Filters
 * @param {string} SearchRecipientsData.UnsubscriptionType
 * @param {string} SearchRecipientsData.UnsubscriptionSubType
 * @param {number} SearchRecipientsData.UnsubscriptionMessage
 * @param {string} SearchRecipientsData.Email
 * @param {('EXACT'|'CONTAINS'|'STARTWITH'|'ENDWITH')} SearchRecipientsData.EmailMatchType
 * @param {string} SearchRecipientsData.MobilePrefix
 * @param {string} SearchRecipientsData.MobileNumber
 * @param {('All'|'Email'|'Sms')} Channel
 * @param {('Subscribed'|'Pending'|'Unsubscribed')} Status
 *
 */
export const beRecipientUnsubscribeBySearchParams = (
  idList,
  SearchRecipientsData,
  Channel,
  Status,
) => {
  return apiWrapper({
    method: 'put',
    url: endpoints.unsubscribeBySearchParams(idList),
    data: JSON.stringify({
      SearchRecipientsData,
      Channel,
      Status: [Status],
    }),
    headers: {
      'Content-Type': 'application/json',
    },
  }).then(({ data }) => data)
}

/**
 * @description Unsubscribe recipients from a list filtered by manual selection parameters
 * @param {number} idList ID of list
 * @param {('All'|'Email'|'Sms')} Channel
 * @param {Array<number>} SelectedRecipientsID
 * @param {('Any'|'Platform'|'NewsletterLink'|'Import'|'BounceHB'|'FBL'|'UnsubHttp'|'UnsubMailTo'|'Inactive'|'MailBlocked'|'NBH'|'Oblio'|'Undefined')} OptOutType
 * @param {('CONSOLE'|'API'|'RECIPIENT')} webhookSource Default value : CONSOLE
 *
 */
export const beRecipientUnsubscribeBySelectionParams = (
  idList,
  Channel,
  SelectedRecipientsID,
  OptOutType = 'Platform',
  webhookSource = 'CONSOLE',
) => {
  return apiWrapper({
    method: 'put',
    url: endpoints.unsubscribeBySelectionParams(idList, { webhookSource }),
    data: JSON.stringify({ Channel, SelectedRecipientsID, OptOutType }),
    headers: {
      'Content-Type': 'application/json',
    },
  }).then(({ data }) => data)
}

/**
 * @description Unsubscribe email recipients custom by search params
 * @param {number} idList ID of list
 * @param {('CONSOLE'|'API'|'RECIPIENT')} webhookSource Default value : CONSOLE
 * @param {Object} reqData
 *
 */
export const beRecipientUnsubscribeByCustomSearchParams = (
  idList,
  reqData,
  webhookSource = 'CONSOLE',
) => {
  return apiWrapper({
    method: 'put',
    url: endpoints.unsubscribeByCustomSearchParams(idList, { webhookSource }),
    data: JSON.stringify(reqData),
    headers: {
      'Content-Type': 'application/json',
    },
  }).then(({ data }) => data)
}

/**
 * @description Get account dynamic fields
 */
export const beRecipientGetDynamicFieldsDefinition = () => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getDynamicFieldsDefinition,
  }).then(({ data }) => data)
}

/**
 * @description Get a recipient
 * @param {number} idRecipient
 * @returns
 */
export const beRecipientGetRecipient = (idRecipient) => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getRecipient(idRecipient),
  }).then(({ data }) => data)
}

export const beRecipientUpdateRecipient = (idRecipient, data) => {
  return apiWrapper({
    method: 'put',
    url: endpoints.updateRecipient(idRecipient),
    data: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
    },
  }).then(({ data }) => data)
}

/**
 * @description Delete a recipient
 * @param {number} idList ID of the list
 * @param {number} idRecipient ID of recipient
 */
export const beRecipientDeleteRecipient = (idList, idRecipient) => {
  return apiWrapper({
    method: 'delete',
    url: endpoints.deleteRecipient(idList, idRecipient),
  }).then(({ data }) => data)
}

/**
 * @description Copy or Move recipients to a group filtered by search parameters
 * @param {number} idList ID of list
 * @param {number} idGroup ID of target group
 * @param {Object} SearchRecipientsData
 * @param {Object} SearchRecipientsData.DateRanges
 * @param {string} SearchRecipientsData.DateRanges.From ISO string date
 * @param {string} SearchRecipientsData.DateRanges.To ISO string date
 * @param {Array<number>} SearchRecipientsData.IncludeGroups
 * @param {Array<number>} SearchRecipientsData.ExcludeGroups
 * @param {Array<Object>} SearchRecipientsData.MatchingFields {Id: 0, Value: string}
 * @param {Object} SearchRecipientsData.MatchingFilters
 * @param {('All'|'AtLeastOne')} SearchRecipientsData.MatchingFilters.Condition
 * @param {Array<number>} SearchRecipientsData.MatchingFilters.Filters
 * @param {string} SearchRecipientsData.UnsubscriptionType
 * @param {string} SearchRecipientsData.UnsubscriptionSubType
 * @param {number} SearchRecipientsData.UnsubscriptionMessage
 * @param {string} SearchRecipientsData.Email
 * @param {('EXACT'|'CONTAINS'|'STARTWITH'|'ENDWITH')} SearchRecipientsData.EmailMatchType
 * @param {string} SearchRecipientsData.MobilePrefix
 * @param {string} SearchRecipientsData.MobileNumber
 * @param {('All'|'Email'|'Sms')} Channel
 * @param {('Subscribed'|'Pending'|'Unsubscribed')} Status
 * @param {boolean} MoveRecipients
 * @param {boolean} RandomSelectRecipients
 * @param {number} RecipientToSelectRandom
 * @param {Array<number>} MoveFromGroups
 */
export const beRecipientCopyMoveRecipientsToGroupBySearch = (
  idList,
  idGroup,
  SearchRecipientsData,
  Channel,
  Status,
  MoveRecipients,
  RandomSelectRecipients,
  RecipientToSelectRandom,
  MoveFromGroups,
) => {
  return apiWrapper({
    method: 'post',
    url: endpoints.copyMoveRecipientsToGroupBySearch(idList, idGroup),
    data: JSON.stringify({
      SearchRecipientsData,
      Channel,
      Status: [Status],
      MoveRecipients,
      RandomSelectRecipients,
      RecipientToSelectRandom,
      MoveFromGroups,
    }),
    headers: {
      'Content-Type': 'application/json',
    },
  }).then(({ data }) => data)
}

/**
 * @description Copy or Move recipients to a group filtered by manual selection parameters
 * @param {number} idList ID of list
 * @param {number} idGroup ID of target group
 * @param {Array<number>} SelectedRecipientsID
 * @param {boolean} MoveRecipients
 * @param {boolean} RandomSelectRecipients
 * @param {number} RecipientToSelectRandom
 * @param {Array<number>} MoveFromGroups
 */
export const beRecipientCopyMoveRecipientsToGroupByManualSelection = (
  idList,
  idGroup,
  SelectedRecipientsID,
  MoveRecipients,
  RandomSelectRecipients,
  RecipientToSelectRandom,
  MoveFromGroups,
) => {
  return apiWrapper({
    method: 'post',
    url: endpoints.copyMoveRecipientsToGroupByManualSelection(idList, idGroup),
    data: JSON.stringify({
      SelectedRecipientsID,
      MoveRecipients,
      RandomSelectRecipients,
      RecipientToSelectRandom,
      MoveFromGroups,
    }),
    headers: {
      'Content-Type': 'application/json',
    },
  }).then(({ data }) => data)
}

/**
 * @description Copy or Move recipients to a group filtered by custom search parameters
 * @param {number} idList
 * @param {number} idGroup
 * @param {Object} reqIn
 * @param {Array<Object>} reqIn.Conditions
 * @param {Array<Object>} reqIn.SubscriptionStatus
 * @param {boolean} reqIn.MoveRecipients
 * @param {boolean} reqIn.RandomSelectRecipients
 * @param {number} reqIn.RecipientToSelectRandom
 * @param {Array<number>} reqIn.MoveFromGroups
 */
export const beRecipientCopyMoveRecipientsToGroupByCustomSearch = (
  idList,
  idGroup,
  reqIn,
) => {
  return apiWrapper({
    method: 'post',
    url: endpoints.copyMoveRecipientsToGroupByCustomSearch(idList, idGroup),
    data: JSON.stringify(reqIn),
    headers: {
      'Content-Type': 'application/json',
    },
  }).then(({ data }) => data)
}

/**
 * @description Create a new group
 * @param {object} groupData
 * @param {number} groupData.IdList
 * @param {string} groupData.Name
 * @param {string} groupData.Notes
 * @param {boolean} groupData.Deleteable
 * @param {('Normal'|'Test'|'SubscriptionForm'|'AutoprofileForm'|'SocialPlus'|'Temporary')} groupData.Type
 * @param {boolean} [groupData.Keepinactiverecipient]
 */
export const beRecipientAddGroup = (groupData) => {
  return apiWrapper({
    method: 'post',
    url: endpoints.addGroup,
    data: JSON.stringify(groupData),
    headers: {
      'Content-Type': 'application/json',
    },
  }).then(({ data }) => data)
}

/**
 * @description Update a group
 * @param {number} idGroup
 * @param {object} groupData
 * @param {number} groupData.IdList
 * @param {string} groupData.Name
 * @param {string} groupData.Notes
 * @param {boolean} groupData.Deleteable
 * @param {('Normal'|'Test'|'SubscriptionForm'|'AutoprofileForm'|'SocialPlus'|'Temporary')} groupData.Type
 * @param {boolean} [groupData.Keepinactiverecipient]
 */
export const beRecipientUpdateGroup = (idGroup, groupData) => {
  return apiWrapper({
    method: 'put',
    url: endpoints.updateGroup(idGroup),
    data: JSON.stringify(groupData),
    headers: {
      'Content-Type': 'application/json',
    },
  }).then(({ data }) => data)
}

/**
 * @description Get group details by id
 * @param {number} idGroup
 */
export const beRecipientGetGroupDetails = (idGroup) => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getGroupDetails(idGroup),
  }).then(({ data }) => data)
}

/**
 * @description Get unsubscription count by type
 * @param {number} idList
 */
export const beRecipientGetOptoutType = (idList) => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getOptoutType(idList),
  }).then(({ data }) => data)
}
export const beRecipientGetEmailRecipientTracking = (idRecipient, idList) => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getEmailRecipientTracking(idRecipient, idList),
  }).then(({ data }) => data)
}

/**
 * @description get Recipient dett
 * @param {number} idRecipient
 */
export const getRecipient = (idRecipient) => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getRecipient(idRecipient),
  }).then(({ data }) => data)
}

/**
 * @description Sets the tracking state for the recipient in the specified list
 * @param {number} idRecipient
 * @param {number} idList
 * @param {boolean} enable
 */
export const beRecipientUpdateEmailRecipientTracking = (
  idRecipient,
  idList,
  enable,
) => {
  const updatePayload = {
    Enable: enable,
    IdMessage: 0,
    RemoteIP: '',
  }
  const url = endpoints.updateEmailRecipientTracking(idRecipient, idList)
  return apiWrapper({
    method: 'put',
    url,
    data: JSON.stringify(updatePayload),
    headers: {
      'Content-Type': 'application/json',
    },
  }).then(({ data }) => data)
}

/**
 * @description Get a single subscritpion from specified list
 * @param {number} idRecipient ID of recipient
 * @param {number} idList ID of list
 *
 */
export const beRecipientGetSmsSubscriptionFromList = (idRecipient, idList) => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getSmsSubscriptionFromList(idRecipient, idList),
    headers: {
      'Content-Type': 'application/json',
    },
  }).then(({ data }) => data)
}

/**
 * @description Get a single subscritpion from specified list
 * @param {number} idRecipient ID of recipient
 * @param {number} idList ID of list
 *
 */
export const beRecipientGetEmailSubscriptionFromList = (
  idRecipient,
  idList,
) => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getEmailSubscriptionFromList(idRecipient, idList),
    headers: {
      'Content-Type': 'application/json',
    },
  }).then(({ data }) => data)
}

export const beRecipientGetEmailSubscriptionData = (idList, idRecipient) => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getEmailSubscriptionData(idList, idRecipient),
    headers: {
      'Content-Type': 'application/json',
    },
  }).then(({ data }) => data)
}

export const beRecipientGetEmailActivity = (
  idList,
  idRecipient,
  params,
  data,
) => {
  return apiWrapper({
    method: 'post',
    url: endpoints.getEmailRecipientActivity(idList, idRecipient, params),
    data: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
    },
  }).then(({ data }) => data)
}

export const beRecipientGetSmsActivity = (
  idList,
  idRecipient,
  params,
  data,
) => {
  return apiWrapper({
    method: 'post',
    url: endpoints.getSmsRecipientActivity(idList, idRecipient, params),
    data: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
    },
  }).then(({ data }) => data)
}

export const beRecipientPutInactiveConfiguration = (idList, data) => {
  return apiWrapper({
    method: 'put',
    url: endpoints.inactiveRecipientsConfiguration(idList),
    data: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
    },
  })
}

export const beRecipientGetInactiveConfiguration = (idList) => {
  return apiWrapper({
    method: 'get',
    url: endpoints.inactiveRecipientsConfiguration(idList),
    headers: {
      'Content-Type': 'application/json',
    },
  }).then(({ data }) => data)
}

/**
 * @description Get idTask for Count-Simulation of Inactive Recipients
 * @param {number} idList ID of list
 * @param {number} monthsPeriod how many months of inactivity
 *
 */
export const beRecipientGetInactiveCount = (idList, monthsPeriod) => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getInactiveRecipientsCount(idList, monthsPeriod),
    headers: {
      'Content-Type': 'application/json',
    },
  }).then(({ data }) => data)
}

export const beRecipientApiCustomSearchForRecipients = (
  idList,
  qsParams,
  customSearchIn,
) => {
  return apiWrapper({
    method: 'post',
    url: endpoints.customSearchForRecipients(idList, qsParams),
    headers: {
      'Content-Type': 'application/json',
    },
    data: JSON.stringify(customSearchIn),
  }).then(({ data }) => data)
}

export const beRecipientApiHasRecipients = (idList) => {
  return apiWrapper({
    url: endpoints.hasRecipients(idList),
  }).then(({ data }) => data)
}

export const beRecipientApiGetLoginConfidentialDefinitions = (idUser) => {
  return apiWrapper({
    url: endpoints.getLoginConfidentialDefinitions(idUser),
  }).then(({ data }) => data)
}

export const beRecipientApiExportBySelectionParams = (
  idList,
  qsParams,
  customSearchIn,
) => {
  return apiWrapper({
    method: 'put',
    url: endpoints.exportBySelectionParams(idList, qsParams),
    headers: {
      'Content-Type': 'application/json',
    },
    data: JSON.stringify(customSearchIn),
  }).then(({ data }) => data)
}

export const beRecipientApiExportByCustomSearchParams = (
  idList,
  qsParams,
  customSearchIn,
) => {
  return apiWrapper({
    method: 'put',
    url: endpoints.exportByCustomSearchParams(idList, qsParams),
    headers: {
      'Content-Type': 'application/json',
    },
    data: JSON.stringify(customSearchIn),
  }).then(({ data }) => data)
}

/**
 *
 * @param {number} idRecipient
 * @param {object} qsParams
 * @param {number} qsParams.idList
 * @param {number} qsParams.pageSize
 * @param {number} qsParams.pageNumber
 * @param {string} qsParams.orderBy 'IdGroup'|'GroupName'|'AssignmentDate'
 * @param {boolean} qsParams.orderDescending
 * @returns
 */
export const beRecipientApiGetRecipientGroupAssignements = (
  idRecipient,
  qsParams = {},
) => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getRecipientGroupAssignements(idRecipient, qsParams),
    headers: {
      'Content-Type': 'application/json',
    },
  }).then(({ data }) => data)
}

/**
 * @returns {Promise}
 */
export const beRecipientApiAssignRecipientToGroup = (
  idRecipient,
  idGroup,
  idList,
) => {
  return apiWrapper({
    method: 'post',
    url: endpoints.assignRecipientToGroup(idRecipient, idGroup, idList),
    headers: {
      'Content-Type': 'application/json',
    },
  }).then(({ data }) => data)
}

export const beRecipientApiRemoveRecipientFromGroup = (
  idRecipient,
  idGroup,
  idList,
) => {
  return apiWrapper({
    method: 'delete',
    url: endpoints.removeRecipientFromGroup(idRecipient, idGroup, idList),
    headers: {
      'Content-Type': 'application/json',
    },
  }).then(({ data }) => data)
}

/**
 *
 * @param {number[]} Ids
 * @returns
 */
export const beRecipientApiGetGroupDetailsByIds = (Ids) => {
  return apiWrapper({
    method: 'post',
    url: endpoints.getGroupDetailsByIds,
    headers: {
      'Content-Type': 'application/json',
    },
    data: JSON.stringify({
      Ids,
    }),
  }).then(({ data }) => data)
}

export const CHANNEL_TYPE_ALL = 'All'
export const CHANNEL_TYPE_EMAIL = 'Email'
export const CHANNEL_TYPE_SMS = 'Sms'

export const SUBSCRIPTION_TYPE_SUBSCRIBED = 'Subscribed'
export const SUBSCRIPTION_TYPE_PENDING = 'Pending'
export const SUBSCRIPTION_TYPE_UNSUBSCRIBED = 'Unsubscribed'

export const OPTOUT_TYPE_ANY = 'Any'
export const OPTOUT_TYPE_PLATFORM = 'Platform'
export const OPTOUT_TYPE_NEWSLETTER_LINK = 'NewsletterLink'
export const OPTOUT_TYPE_IMPORT = 'Import'
export const OPTOUT_TYPE_BOUNCE_HB = 'BounceHB'
export const OPTOUT_TYPE_FBL = 'FBL'
export const OPTOUT_TYPE_UNSUB_HTTP = 'UnsubHttp'
export const OPTOUT_TYPE_UNSUB_MAILTO = 'UnsubMailTo'
export const OPTOUT_TYPE_INACTIVE = 'Inactive'
export const OPTOUT_TYPE_MAIL_BLOCKED = 'MailBlocked'
export const OPTOUT_TYPE_NBH = 'NBH'
export const OPTOUT_TYPE_OBLIO = 'Oblio'
export const OPTOUT_TYPE_UNDEFINED = 'Undefined'

export const GROUP_TYPE_NORMAL = 'Normal'
export const GROUP_TYPE_TEST = 'Test'

export const GROUPS_SEARCH_TYPE_EQUALTO = 'EQUALTO'
export const GROUPS_SEARCH_TYPE_ECONTAINS = 'CONTAINS'

export const RECIPIENT_STATUS_OPTIN = 0
export const RECIPIENT_STATUS_PENDING = 1
export const RECIPIENT_STATUS_OPTOUT = 2

export const ACTIVITY_EVENT_TYPE_SUBSCRIPTIONREQUEST = 'SubscriptionRequest'
export const ACTIVITY_EVENT_TYPE_SUBSCRIPTIONCONFIRMATION =
  'SubscriptionConfirmation'
export const ACTIVITY_EVENT_TYPE_SUBSCRIPTION = 'Subscription'
export const ACTIVITY_EVENT_TYPE_UNSUBSCRIPTION = 'Unsubscription'
export const ACTIVITY_EVENT_TYPE_OPENS = 'Opens'
export const ACTIVITY_EVENT_TYPE_CLICKS = 'Clicks'
export const ACTIVITY_EVENT_TYPE_BOUNCES = 'Bounces'
export const ACTIVITY_EVENT_TYPE_SENDINGS = 'Sendings'
